module.exports = __webpack_public_path__ + "static/media/menu.61e25078.svg";